export default "__VITE_ASSET__CXsnobye__"